import React from "react";
import type { IconProps } from "./icon.types";

export function SendMessage({ size = 24, ...props }: IconProps): React.ReactElement {
  return (
    <svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M19.5 2a3.5 3.5 0 0 1 3.031 5.25l-7.5 12.99a3.5 3.5 0 0 1-6.41-.842l-1.768-6.594l-4.828-4.83A3.5 3.5 0 0 1 4.5 2zm-15 2a1.5 1.5 0 0 0-1.06 2.56l4.474 4.475l6.977-4.028a1 1 0 0 1 1 1.732l-6.977 4.029l1.638 6.11a1.5 1.5 0 0 0 2.747.361l7.5-12.989A1.5 1.5 0 0 0 19.5 4z"
      />
    </svg>
  );
}
